goog.provide("shadow.js.shim.module$src$svg$location$globe_europe_africa_svg$default");
shadow.js.shim.module$src$svg$location$globe_europe_africa_svg$default = shadow.js.shim.module$src$svg$location$globe_europe_africa_svg.default;
